import { GridItem } from '@chakra-ui/react';
import { ListRow } from 'components/molecules/ListRow';
import { FC } from 'react';
import { TextWithTooltip } from 'components/molecules/TextWithTooltip';
import { Crawler } from 'types/crawler';

type Props = {
  /** クローラー情報 */
  item: Crawler;
  /** 行クリックイベントのハンドラ */
  handleClickRow: () => void;
};

export const CrawlerListItem: FC<Props> = ({ item, handleClickRow }) => (
  <ListRow onClick={handleClickRow} templateColumns="1fr 2fr 3fr">
    <GridItem>
      <TextWithTooltip text={item.id.toString()} />
    </GridItem>
    <GridItem>
      <TextWithTooltip
        text={item.name}
        textMaxWidth="300px"
        visibleTooltip
        tooltipMaxWidth="600px"
      />
    </GridItem>
    <GridItem>
      <TextWithTooltip
        text={item.imageName}
        textMaxWidth="300px"
        visibleTooltip
        tooltipMaxWidth="600px"
      />
    </GridItem>
  </ListRow>
);
